import { render, staticRenderFns } from "./MportsGrid.vue?vue&type=template&id=12d4947d"
import script from "./MportsGrid.vue?vue&type=script&lang=js"
export * from "./MportsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports